import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { SiteMenu } from "@/components/site/SiteMenu";
import { SideIcons } from "@/components/site/SideIcons";
import { SiteFooter } from "@/components/site/SiteFooter";

let siteCache = null;

export function useSiteData() {
  const [data, setData] = useState(siteCache);
  useEffect(() => {
    let alive = true;
    if (!siteCache && process.env.REACT_APP_BACKEND_URL) {
      axios
        .get(`${API}/site`)
        .then((r) => {
          siteCache = { menu: Array.isArray(r.data?.menu) ? r.data.menu : [], home: Array.isArray(r.data?.home) ? r.data.home : [] };
          if (alive) setData(siteCache);
        })
        .catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, []);
  return data;
}

export const SiteShell = ({ variant, infoOpen, onInfo, children }) => {
  const site = useSiteData();
  return (
    <div className={`jt jt--${variant}`}>
      <SiteMenu items={site?.menu} />
      <SideIcons infoOpen={infoOpen} onInfo={onInfo} />
      <main id="content">{children}</main>
      <SiteFooter />
    </div>
  );
};
